import isNumber from "./number";

export default function isMax(value, max) {
  if (isNumber(value)) {
    return Number(value) <= max;
  } else if (typeof value === "string") {
    return value.length <= max;
  }

  return false;
}
